import UserMenu from './user-menu';
import { useStoredMessagesContext } from '../stored-messages-provider';
import { useMessagesContext } from '../messages-provider';
import './styles.less';
const {
  useState
} = React;
const {
  ReactIcon: Icon,
  ReactIconButton: IconButton
} = svs.ui;
const {
  SiteHeaderBrand,
  SiteWrapper
} = svs.retailUi;
const {
  isAnonymous
} = svs.core.session.data.userSession;
const Badge = svs.ui.ReactBadge;
const SiteHeader = ({
  hasMenu,
  onToggleMenu,
  username,
  userRole
}) => {
  const {
    showReadInfo
  } = useStoredMessagesContext();
  const {
    unreadMessagesCount
  } = useMessagesContext();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  return <header className="site-header">
      <div className="header header-default" id="top-content" role="banner">
        <div className="header-content">
          <SiteHeaderBrand />
          {hasMenu && <React.Fragment>
              <UserMenu isOpen={isUserMenuOpen} onClose={() => setIsUserMenuOpen(false)} username={username} userRole={userRole} />
              <button aria-controls="navigation-menu-main" aria-expanded="false" aria-label="Meny" className="nav-hamburger icon-button fc-black hamburger-icon" onClick={onToggleMenu} type="button">
                <Icon icon="menu" />
              </button>

            </React.Fragment>}
          {isDrawerOpen && <div className="site-menu visible-xs">
              <div className="close-icon">
                <IconButton onClick={() => setDrawerOpen(false)}>
                  <Icon icon="close" />
                </IconButton>

              </div>
              <div className="menu">
                <SiteWrapper />
              </div>
            </div>}

          {!isAnonymous && <button aria-controls="navigation-menu-main" aria-expanded="false" aria-label="Meny" className="nav-user icon-button fc-black" onClick={() => setIsUserMenuOpen(true)} type="button">
              <div className="header-icon-wrapper">
                <Icon icon="user" />
                {showReadInfo && unreadMessagesCount > 0 && <Badge branding="red" size="small">
                    {unreadMessagesCount}
                  </Badge>}
              </div>
              <span className="nav-hamburger-title">
                {username}
              </span>
            </button>}
        </div>
      </div>
    </header>;
};
export default SiteHeader;